import { getBrandAdminApiBaseUrl } from "./apiConfig";

const rawApiBase = getBrandAdminApiBaseUrl();

// Normalize base URL once so calls like api("/login") never produce "//login".
export const API_BASE = rawApiBase.replace(/\/+$/, "");

const buildApiUrl = (endpoint = "") => {
  const normalizedEndpoint = `/${String(endpoint || "").replace(/^\/+/, "")}`;
  return `${API_BASE}${normalizedEndpoint}`;
};

// Auth via HttpOnly cookie (credentials: 'include'). Do not attach JWT from localStorage.
export const api = (endpoint, options = {}) => {
  const { headers: optionHeaders, ...restOptions } = options;

  return fetch(buildApiUrl(endpoint), {
    method: "GET",
    credentials: "include",
    ...restOptions,
    headers: {
      "Content-Type": "application/json",
      ...(optionHeaders || {}),
    },
  });
};
